import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';

import { FormValidationModule } from '@tablesready/common-ui';
import { VerificationRoutingModule } from './verification-routing.module';
import { VerificationComponent } from './verification.component';
import { SERVICES } from './services';
import { VerifyEmailResolver } from './resolvers';
import { ApiClientModule } from '@tablesready/api-client';
import { appVariablesProvider } from '@tablesready/frontend-variables';
import { IonicModule } from '@ionic/angular';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';

@NgModule({
  declarations: [VerificationComponent],
  imports: [
    CommonModule,
    FormsModule,
    ApiClientModule,
    ReactiveFormsModule,
    FormValidationModule,
    VerificationRoutingModule,
    Angulartics2Module,
    IonicModule,
    AlertsModule,
  ],
  providers: [
    VerifyEmailResolver,
    appVariablesProvider,
    ...SERVICES,
  ],
})
export class VerificationModule {
}
